import { useState } from 'react';

const footerLinks = {
  navigation: [
    { label: '最新动态', href: '#updates' },
    { label: '热播推荐', href: '#cards' },
    { label: '精选预告', href: '#media' },
    { label: '移动观影', href: '#app' },
    { label: '影视索引', href: '#index' },
    { label: '热播榜单', href: '#ranking' },
  ],
  support: [
    { label: '联系我们', href: '#contact' },
    { label: '常见问题', href: '#faq' },
    { label: '意见反馈', href: '#contact' },
    { label: '关于我们', href: '#about' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer id="footer" className="pt-16 md:pt-20 pb-8 px-4 md:px-8" style={{ backgroundColor: '#1a1715' }}>
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-base"></i>
              </span>
              <span className="text-lg font-heading font-bold text-foreground-50">
                春色影视
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              高清免费在线观影平台。不缓冲流畅播放，秒开无卡顿极速影视体验，电影电视剧全集实时更新。
            </p>
            <div className="flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-links-line', 'ri-share-forward-line'].map((icon, i) => (
                <span
                  key={i}
                  className="w-8 h-8 flex items-center justify-center rounded-md bg-foreground-50/5 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-200 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-200 mb-4">帮助中心</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-foreground-200 mb-4">订阅更新</h4>
            <p className="text-sm text-foreground-400 mb-3">
              获取最新影视上架通知和平台动态
            </p>
            {subscribed ? (
              <div className="flex items-center gap-2 px-4 py-3 rounded-md bg-secondary-500/10 border border-secondary-500/20 text-sm text-secondary-400">
                <i className="ri-check-line"></i>
                订阅成功！
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  className="flex-1 px-3 py-2.5 rounded-md bg-foreground-50/5 border border-foreground-50/10 text-sm text-foreground-200 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500/50 transition-colors"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 rounded-md bg-primary-500 text-background-950 text-sm font-medium hover:bg-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-foreground-50/5 pt-6 mb-6">
          <h4 className="text-sm font-heading font-bold text-foreground-300 mb-3">合作伙伴</h4>
          <p className="text-xs text-foreground-500">
            更多合作伙伴信息即将公布，敬请期待。
          </p>
        </div>

        <div className="border-t border-foreground-50/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 春色影视 chunse.tv — 高清免费在线观看，不缓冲秒开播放。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-400 transition-colors">
              隐私政策
            </span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-400 transition-colors">
              服务条款
            </span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-400 transition-colors">
              DMCA
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}